<template>
  <div class="container white pa-0">
    <!-- alertas -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <div v-if="showMain">
      <!-- Modal Loading -->
      <v-dialog persistent max-width="300" v-model="blockScreen">
        <v-card class="px-3 py-5 text-center">
          <div class="text-center pb-5">
            <span class="title font-weight-bold"
              >Aguarde, estamos processando os dados...</span
            >
          </div>
          <v-progress-circular
            :size="70"
            :width="7"
            class="checkin-text"
            indeterminate
          ></v-progress-circular>
        </v-card>
      </v-dialog>
      <!-- menu superior -->
      <v-layout column class="menu w-100 white">
        <v-card elevation="2" tile>
          <v-layout
            align-center
            justify-space-around
            class="py-2 px-3 colorSelectedBack sizeTop"
          >
            <img
              :src="require(`@/assets/logos/uc_carsharing_branco.png`)"
              alt="pickndrive"
              style="width: auto; height: 39px"
            />
          </v-layout>
        </v-card>
      </v-layout>

      <!-- Mudar tela -->
      <v-layout column class="changePage w-100 white">
        <v-card elevation="2" tile>
          <v-layout align-center justify-space-around class="px-3">
            <v-btn
              text
              :class="showNewRequests ? 'colorSelected' : 'grey--text'"
              @click="changePage('new')"
            >
              <span class="subheading font-weight-medium">Reservas</span>
            </v-btn>
            <v-divider vertical class="ma-0"></v-divider>
            <v-btn
              text
              :class="showOldRequests ? 'colorSelected' : 'grey--text'"
              @click="changePage('old')"
            >
              <span class="subheading font-weight-medium">Histórico</span>
            </v-btn>
          </v-layout>
        </v-card>
      </v-layout>

      <div style="height: 96px"></div>

      <!-- modal cancelar -->
      <v-dialog v-model="modalCancel">
        <v-card class="pa-4 text-center">
          <span class="title font-weight-bold"
            >Tem certeza que deseja cancelar a reserva?</span
          >
          <v-flex xs12>
            <v-textarea
              rows="8"
              outline
              hide-details
              color="grey darken-2"
              label="Motivo do cancelamento"
              class="pt-4 pb-3 px-2"
              v-model="motiveCancel"
            ></v-textarea>
          </v-flex>
          <v-flex row class="font-weight-regular ma-0">
            <v-btn text class="btn-error" @click="modalCancel = !modalCancel"
              >Não</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!motiveCancel"
              class="btn-sucess white--text"
              @click="cancelVehicleRequest()"
              >Sim</v-btn
            >
          </v-flex>
        </v-card>
      </v-dialog>

      <!-- pagina de reservas -->
      <div v-if="showNewRequests" class="newRequest py-3 px-2">
        <!-- <ModalFuel
          :show="modalAbastecer"
          :vehicleInfo="abastecerId"
          @close="modalAbastecer = false"
        ></ModalFuel> -->
        <v-btn fab @click="openChat()" class="colorBtn floatBtn">
          <v-icon class="white--text">chat</v-icon>
        </v-btn>

        <!-- se houver reserva ativa -->
        <v-card v-if="requestsInCheckout" class="mx-2 px-2 py-4 moment">
          <v-layout column>
            <span class="title text-center text--darken-1 mb-2"
              >Reserva atual:</span
            >
            <v-alert
              :value="true"
              type="warning"
              class="w-100"
              outline
              dismissible
              v-if="warningMomentRequest"
              >Você está atrasado para fazer o check-out.</v-alert
            >
            <VehicleInformations
              :model="requestsInCheckout.vehicle.vehicle_model.model"
              :url="
                requestsInCheckout.vehicle.vehicle_model.url
                  ? requestsInCheckout.vehicle.vehicle_model.url
                  : 'VIRTUS_AZUL.png'
              "
              :plate="requestsInCheckout.vehicle.plate"
              :gearbox="requestsInCheckout.vehicle.gearbox"
              :doors_qtd="requestsInCheckout.vehicle.doors_qtd"
            ></VehicleInformations>
            <v-divider class="mb-3 mt-0 mx-4"></v-divider>
            <v-layout class="px-4" column>
              <v-layout justify-space-between>
                <span class="font-weight-bold">Check-in:</span>
                <span class="font-weight-regular">{{
                  requestsInCheckout.begin_date | normalizeDate
                }}</span>
              </v-layout>
              <v-layout class="pt-2" justify-space-between>
                <span class="font-weight-bold">Check-out:</span>
                <span class="font-weight-regular">{{
                  requestsInCheckout.end_date | normalizeDate
                }}</span>
              </v-layout>
            </v-layout>
            <v-divider class="my-2 mx-4"></v-divider>
            <v-btn
              @click="checkSchedule()"
              large
              color="white"
              class="fontPrimary btnGroup"
              >Prorrogar Check-out</v-btn
            >
            <v-divider class="my-2"></v-divider>
            <v-btn
              @click="goToCheck(requestsInCheckout.id)"
              large
              class="checkout white--text btnGroup"
              >Fazer Check-out</v-btn
            >
            <!-- <v-btn @click="openDoors(requestsInCheckout.id)" large class="btnColor white--text">Abrir portas</v-btn> -->
            <!-- <v-btn
              :disabled="dialog"
              :loading="dialog"
              class="white--text"
              color="purple darken-2"
              @click="dialog = true"
            > -->
            <v-layout class="newConteiner" row>
              <v-btn
                width="40px"
                v-if="requestsInCheckout.vehicle.card_password"
                @click="
                  $router.push({
                    name: 'vehicle-request-refuel',
                    params: {
                      vehicleRequestId: requestsInCheckout.id,
                    },
                  })
                "
                text
                class="fontPrimary btnGroup pl-3"
                >Abastecer
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                ma-3
                width="40px"
                :disabled="dialog"
                :loading="dialog"
                @click="
                  openDoors(requestsInCheckout.vehicle.id);
                  dialog = true;
                "
                class="fontPrimary btnGroup pr-3"
                text
              >
                Abrir portas
              </v-btn>
            </v-layout>

            <v-dialog v-model="dialog" hide-overlay persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Aguarde, enviando comando...
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-card>

        <!-- se não houver reservas ativas ou futuras-->
        <v-card
          min-height="180px"
          class="mx-2 px-2 py-4 bottom"
          v-if="requestsInCheckIn.length == 0 && !requestsInCheckout"
        >
          <v-layout column class="text-center">
            <span class="title text-center grey--text text--darken-1 px-4"
              >Nenhuma reserva ativa ou futura</span
            >
            <v-icon class="icon-size py-4">alarm_off</v-icon>
            <v-btn
              large
              class="btnColor mx-5 px-0"
              @click="$router.push('/user/solicitar-reserva')"
            >
              <span class="white--text font-weight-medium"
                >Fazer nova reserva</span
              >
            </v-btn>
          </v-layout>
        </v-card>

        <v-layout
          column
          class="text-center pb-5"
          v-if="requestsInCheckIn.length != 0"
        >
          <v-btn large text class="btnInfo mx-5 px-8" @click="info()">
            <v-icon class="py-4" color="#993399"
              >mdi-alert-circle-outline</v-icon
            >
            <!--<img class="float-left" src="../../assets/icons/back.png" />-->
            <span class="text-center font-weight-medium pr-4 pl-2"
              >Informações da reserva
            </span>
            <img class="float-right" src="../../assets/icons/advance.png" />
          </v-btn>
        </v-layout>

        <!-- se houver reservas futuras -->
        <v-card
          min-height="180px"
          class="mx-2 px-2 py-4 bottom"
          v-if="requestsInCheckIn.length != 0"
        >
          <v-layout column>
            <span class="text-center title grey--text text--darken-1 mb-2"
              >Reserva(s) futura(s):</span
            >
            <!-- para cada reserva futura -->
            <v-layout
              column
              justify-center
              v-for="(items, index) in requestsInCheckIn"
              :key="index"
            >
              <v-card text class="vehicle mb-2 mt-3 pa-3">
                <div class="contentLeft">
                  <span class="modelo">{{
                    items.vehicle.vehicle_model.model
                  }}</span>
                  <br />
                  <img
                    class="vehicleImg"
                    style="max-width: 186px; height: auto"
                    :src="`${url_bucket}${items.vehicle.vehicle_model.url}`"
                  />
                  <br />
                  <span class="body-1 total">Placa:</span>
                  <span class="pl-2 body-1 total">{{
                    items.vehicle.plate
                  }}</span>
                  <br />
                </div>
                <div class="contentRight pt-2 pl-2">
                  <!-- <div class="pb-1">
                    <img src="../../assets/icons/icon1.png" />
                    <span v-if="items.transaction.length == 0" class="pl-2 caption">R$0,00</span>
                    <span v-if="items.transaction.length != 0" class="pl-2 caption">{{items.transaction[0].valor_pre_autorizado | money}}</span>
                  </div> -->
                  <div class="pb-1">
                    <img src="../../assets/icons/icon2.png" />
                    <span class="pl-2 caption">{{
                      items.vehicle.gearbox ? 'Automático' : 'Manual'
                    }}</span>
                  </div>
                  <div class="pb-1">
                    <img src="../../assets/icons/icon3.png" />
                    <span class="pl-2 caption">Flex</span>
                  </div>
                  <div class="pb-1">
                    <img src="../../assets/icons/icon4.png" />
                    <span class="pl-2 caption"
                      >{{ items.vehicle.doors_qtd }} Portas</span
                    >
                  </div>
                  <div class="pb-1">
                    <img src="../../assets/icons/icon5.png" />
                    <span class="pl-2 caption">Ar Condicionado</span>
                  </div>
                </div>
              </v-card>
              <v-divider class="my-3 mx-4"></v-divider>
              <v-layout class="px-4" column>
                <v-layout justify-space-between>
                  <span class="checkin-text font-weight-bold">Check-in:</span>
                  <span class="total font-weight-regular">{{
                    items.begin_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout class="pt-2" justify-space-between>
                  <span class="checkout-text font-weight-bold">Check-out:</span>
                  <span class="total font-weight-regular">{{
                    items.end_date | normalizeDate
                  }}</span>
                </v-layout>
              </v-layout>
              <v-divider class="my-3 mx-4"></v-divider>
              <v-btn
                @click="goToCheck(items.id)"
                large
                class="checkin white--text btnGroup"
                :disabled="!items.allowCheckIn"
                >Fazer Check-in</v-btn
              >
              <v-btn
                @click="checkTimeCancel(items.id)"
                v-if="cancelTime"
                large
                text
                class="btnGroup"
                >Cancelar Reserva</v-btn
              >
            </v-layout>
          </v-layout>
        </v-card>
      </div>

      <!-- pagina de historico -->
      <div v-if="showOldRequests" class="oldRequest py-3 px-2">
        <!-- se não houver reservas antigas-->
        <v-card class="mx-2 px-2 py-4" v-if="!haveOldRequest">
          <v-layout column class="text-center">
            <span class="title grey--text text--darken-1 px-4"
              >Nenhuma reserva antiga</span
            >
            <v-icon class="icon-size py-4">alarm_off</v-icon>
            <v-btn
              large
              class="btnColor mx-5 px-0"
              @click="$router.push('/user/newVR')"
            >
              <span class="white--text font-weight-medium"
                >Fazer nova reserva</span
              >
            </v-btn>
          </v-layout>
        </v-card>

        <div v-if="haveOldRequest" class="bottom">
          <!-- para cada reserva antiga-->
          <v-card
            v-for="(items, index) in vehicleRequests"
            :key="index"
            class="mx-2 mb-2 px-2 pt-2 py-3"
          >
            <v-layout column justify-center>
              <v-layout px-2 column>
                <v-layout class="pt-2" justify-space-between>
                  <span class="total subheading font-weight-bold"
                    >{{ items.vehicle.vehicle_model.model }} -
                    {{ items.vehicle.plate }}</span
                  >
                  <v-btn
                    v-if="cancelledItem(items)"
                    @click="openDatails(items)"
                    icon
                    class="float mt-2"
                    ><v-icon>info</v-icon></v-btn
                  >
                  <span
                    v-if="!cancelledItem(items)"
                    class="error--text subheading font-weight-bold"
                    >Cancelada</span
                  >
                </v-layout>
                <v-layout
                  v-if="
                    items.vehicleRequestStep[0] &&
                    items.vehicleRequestStep[0].cancel_date
                  "
                  class="pt-3"
                  justify-space-between
                >
                  <span class="total font-weight-bold">Cancelada em:</span>
                  <span class="total font-weight-regular">{{
                    items.vehicleRequestStep[0].cancel_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout class="pt-3" justify-space-between>
                  <span class="total font-weight-bold">Check-in:</span>
                  <span class="total font-weight-regular">{{
                    items.begin_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout class="pt-2" justify-space-between>
                  <span class="total font-weight-bold">Check-out:</span>
                  <span class="total font-weight-regular">{{
                    items.end_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout class="pt-3" justify-space-between>
                  <span class="total font-weight-bold">Total:</span>
                  <span
                    v-if="items.transaction.length == 0"
                    class="total font-weight-bold"
                    >R$ 0,00</span
                  >
                  <span
                    v-if="items.transaction.length != 0"
                    class="total font-weight-bold"
                  >
                    {{
                      totalValue(
                        items.transaction[0].valor_pre_autorizado,
                        items.total_km_value,
                        items.penalty_value
                      ) | money
                    }}
                  </span>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-card>
          <Observer v-on:intersect="intersected"></Observer>
        </div>

        <v-dialog v-model="infoRequest">
          <datail
            v-if="infoRequest"
            :vehicleRequest="vehicleRequestsDatail"
            @changeDialog="changeDialog()"
          />
        </v-dialog>
      </div>
      <payment
        :showModal="showModalCreditCard"
        :showClose="false"
        @close="close()"
        @alert="mensagemAlerta($event)"
      ></payment>

      <v-dialog width="400px" persistent v-model="modalExtension">
        <v-card class="py-3" width="400" :height="allowed ? '525' : '230'">
          <v-btn icon class="float" @click="extensionStep(3)">
            <v-icon color="black">close</v-icon>
          </v-btn>
          <v-layout
            column
            align-center
            justify-center
            text-center
            class="headline font-weight-bold py-4"
          >
            <span>Alterar Checkout </span>
            <span> </span>
          </v-layout>

          <div v-if="allowed">
            <div v-if="this.Nextcheckin != null" class="card-padding">
              <span> Carro disponível pra check-out até às</span>
              <span class="h5 fontPrimary"> {{ this.Nextcheckin }}</span>
            </div>

            <div v-if="SelectedDate">
              <v-date-picker
                color="var(--primary-color)"
                :min="checkoutDate"
                title="Novo horário de check-out:"
                :reactive="true"
                width="100%"
                locale="pt-br"
                @input="dateInput = false"
                v-model="NewCheckout.date"
              >
              </v-date-picker>
            </div>

            <div v-else>
              <v-time-picker
                color="var(--primary-color)"
                :allowed-minutes="allowedStep"
                full-width
                format="24hr"
                locale="pt-br"
                v-model="NewCheckout.hours"
                @input="allowContinue = true"
              >
              </v-time-picker>
            </div>
            <div v-if="SelectedDate" class="rightButtons">
              <v-btn
                class="fontPrimary font-weight-bold"
                text
                :disabled="dateInput"
                @click="extensionStep(1)"
                >Próximo</v-btn
              >
            </div>

            <div v-else class="rightButtons">
              <v-btn
                class="fontPrimary font-weight-bold"
                text
                @click="extensionStep(3)"
                >Cancelar</v-btn
              >
              <v-btn
                class="fontPrimary font-weight-bold"
                text
                :disabled="!allowContinue"
                @click="extensionStep(2)"
                >Ok</v-btn
              >
            </div>
          </div>
          <div v-else>
            <v-layout column align-center justify-center text-center>
              <div class="pb-6 pt-6">
                A prorrogação do check-out não está disponível para essa
                reserva.
              </div>

              <v-btn
                width="300"
                @click="modalExtension = false"
                class="backgroundPrimary white--text"
                >OK</v-btn
              >
            </v-layout>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <div v-if="showNewdetails">
      <v-dialog persistent max-width="300" v-model="blockScreen">
        <v-card class="px-3 py-5 text-center">
          <div class="text-center pb-5">
            <span class="title font-weight-bold"
              >Aguarde, estamos processando os dados...</span
            >
          </div>
          <v-progress-circular
            :size="70"
            :width="7"
            class="checkin-text"
            indeterminate
          ></v-progress-circular>
        </v-card>
      </v-dialog>
      <v-layout column class="menu w-100 white">
        <v-card elevation="2" tile>
          <v-layout
            align-center
            justify-space-around
            class="py-2 px-3 colorSelectedBack sizeTop"
          >
            <img
              :src="require(`@/assets/logos/uc_carsharing_branco.png`)"
              alt="pickndrive"
              style="width: auto; height: 39px"
            />
          </v-layout>
        </v-card>
      </v-layout>
      <div class="y-spacing">
        <div class="title text-center text--darken-1">
          Detalhes da prorrogação:
        </div>

        <v-flex>
          <VehicleInformations
            :model="requestsInCheckout.vehicle.vehicle_model.model"
            :url="
              requestsInCheckout.vehicle.vehicle_model.url
                ? requestsInCheckout.vehicle.vehicle_model.url
                : 'VIRTUS_AZUL.png'
            "
            :plate="requestsInCheckout.vehicle.plate"
            :gearbox="requestsInCheckout.vehicle.gearbox"
            :doors_qtd="requestsInCheckout.vehicle.doors_qtd"
          ></VehicleInformations>
        </v-flex>
        <v-divider></v-divider>
        <v-layout justify-space-between>
          <span class="defaultPadding font-weight-bold">Check-out: </span>
          <span class="pr-3">
            {{ requestsInCheckout.end_date | normalizeDate }}
          </span>
        </v-layout>
        <v-layout justify-space-between>
          <span class="pt-1 defaultPadding font-weight-bold"
            >Novo Check-out:
          </span>
          <span class="pt-1 pr-3">
            {{ NewCheckout.date_hour | normalizeDate }}
          </span>
        </v-layout>

        <div class="pa-3">
          <v-layout justify-space-between>
            <span align-center>Valor adicional da reserva: </span>
            <span class="font-weight-bold">{{
              RequestadditionalValue.vehicleRequestPriceInCents | money
            }}</span>
          </v-layout>
        </div>
        <v-divider></v-divider>
        <v-flex class="justify-content-center">
          <v-flex ma-5>
            <span align-center>Selecione o metodo de pagamento: </span>
          </v-flex>
          <v-flex class="d-flex" ma-5>
            <v-select
              width="70%"
              :items="cards"
              item-text="nickname"
              item-value="id"
              label="Cartão de Crédito"
              color="orange"
              prepend-inner-icon="credit_card"
              no-data-text="Nenhum cartão cadastrado"
              v-model="cardId"
              solo
              hide-details
            ></v-select>
            <v-btn
              fab
              small
              class="colorBtn my-auto ml-2 mr-0"
              @click="$router.push('/user/pagamento')"
            >
              <v-icon color="white">add</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
        <v-divider></v-divider>
        <v-flex class="d-flex justify-content-center">
          <v-btn
            large
            width="80%"
            text
            class="checkout white--text btnGroup"
            @click="extendReservation()"
          >
            confirmar prorrogação</v-btn
          >
        </v-flex>

        <v-flex class="d-flex justify-content-center">
          <v-btn
            large
            width="80%"
            class="fontPrimary btnGroup"
            @click="showDetails()"
            >cancelar</v-btn
          >
        </v-flex>
      </div>
    </div>
  </div>
</template>

<script>
import theming from '../../mixins/theming';
import UserController from '../../controllers/UserController';
import VehicleRequest from '../../controllers/VehicleRequestController.js';
import User from './../../models/User.js';
import modal from '../shared/ModalPadrao.vue';
import datail from '../user/VehicleRequestDatail.vue';
import moment from 'moment';
import VehicleController from './../../controllers/VehicleController.js';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import ConfigurationController from '../../controllers/ConfigurationController.js';
import CreditCardController from '../../controllers/UserCreditCardController';
import ExtensionController from '../../controllers/ReservationExtensionController.js';
import PromotionController from '../../controllers/PromotionController';
import Constants from '../../models/constants/Constants';
import Observer from '../shared/Observer';
import payment from './ModalPayment.vue';
import Information from '../shared/ReservationInformation.vue';
import VehicleInformations from '../shared/VehicleInformations';

export default {
  mixins: [theming],

  components: {
    modal,
    datail,
    Observer,
    payment,
    Information,
    VehicleInformations,
    VehicleInformations,
  },

  async created() {
    this.blockScreen = true;
    this.getConfigurations();
    await this.getAllVehicleRequests();
    this.blockScreen = false;
    await this.checkCreditCard();
    window.setInterval(() => {
      this.getRequestInCheckIn();
    }, 60000);
  },

  filters: {
    money(str) {
      str = 'R$ ' + parseFloat(str / 100).toFixed(2);
      return str.replace('.', ',');
    },
    normalizeDate(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[/]MM[/]YYYY [-] HH:mm');
    },
  },

  data() {
    return {
      cards: [],
      checkoutDate: '00:00',
      cardId: null,
      RequestadditionalValue: null,
      Nextcheckin: null,
      allowContinue: false,
      SelectedDate: true,
      dateInput: true,
      NewCheckout: {},
      showMain: true,
      showNewdetails: false,
      allowed: true,
      modalExtension: false,
      blockScreen: false,
      showNewRequests: true,
      showOldRequests: false,
      haveMomentRequest: true,
      haveFutureRequest: true,
      warningMomentRequest: false,
      cancelTime: true,
      haveOldRequest: true,
      infoRequest: false,
      value: 4,
      promotionController: new PromotionController(this.$resource),
      userController: new UserController(this.$resource),
      VehicleRequestResource: new VehicleRequest(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      creditCardController: new CreditCardController(this.$resource),
      ExtensionController: new ExtensionController(this.$resource),
      configurations: {},
      user: new User(),
      modalComplete: false,
      vehicleRequests: [],
      vehicleRequestsNext: {
        page: 1,
        limit: 5,
      },
      requestsInCheckout: null,
      requestsInCheckIn: [],
      modalCancel: false,
      motiveCancel: '',
      canlcelId: null,
      vehicleRequestsDatail: null,
      dialog: false,
      responseDoors: {},
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      modalAbastecer: false,
      abastecerId: {},
      showModalCreditCard: false,
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
    };
  },
  watch: {
    dialog(val) {
      if (!val) return;

      setTimeout(() => {
        this.dialog = false;

        this.responseDoors.ok
          ? this.$awn.success(this.responseDoors.mensagem)
          : this.$awn.alert(this.responseDoors.mensagem);
      }, 7000);
    },
  },

  methods: {
    extensionStep(step) {
      //Proxima tela = horas
      if (step == 1) {
        this.dateInput = true;
        this.SelectedDate = false;
        this.allowContinue = false;
      } else if (step == 2) {
        //Proxima tela = confirmação

        var date = this.NewCheckout.date;
        var hour = this.NewCheckout.hours;
        this.NewCheckout.date_hour = date + ' ' + hour + ':00';
        //se Data + Hora for menor que a data de checkout original
        if (this.NewCheckout.date_hour <= this.requestsInCheckout.end_date) {
          this.alert('Data menor ou igual a data de Check-out!', 'error');
        } else {
          this.additionalValue();
          this.showDetails();
        }
      } else {
        //Cancelar e reverter
        this.modalExtension = false;
        this.SelectedDate = true;
        this.allowContinue = false;
      }
    },

    showDetails() {
      this.showMain = !this.showMain;
      this.showNewdetails = !this.showNewdetails;
      this.modalExtension = false;
      this.SelectedDate = true;
      this.checkCreditCard();
    },

    async extensionAvailability() {
      await this.ExtensionController.getExtensionAvailability(
        this.requestsInCheckout.id
      )
        .then((res) => {
          this.Nextcheckin = res.extend_limit;
          this.modalExtension = true;
          this.allowed = true;
        })
        .catch((error) => {
          this.alert(error.body.message, 'error');
          this.allowed = false;
          this.modalExtension = true;
        });
    },
    async additionalValue() {
      let id = this.requestsInCheckout.id; //id da reserva
      let newDate = this.NewCheckout.date_hour; //nova data
      //let activeOffer = this.activePromotion.promotion_recurrent

      await this.ExtensionController.getAdditionalExtensionValue(id, newDate)
        .then((res) => {
          this.RequestadditionalValue = res;
          console.log(this.RequestadditionalValue);
        })
        .catch((error) => {
          console.log(error);
          this.alert(error.body.message, 'error');
        });
    },
    async extendReservation() {
      let id = this.requestsInCheckout.id; //id da reserva
      let newDate = this.NewCheckout.date_hour; //nova data
      let card = this.cardId; // cartão
      //let addOffer = this.activePromotion.promotion_recurrent

      this.blockScreen = true;
      await this.ExtensionController.ExtendReservation(id, newDate, card)
        .then((res) => {
          this.alert(res.message, 'success');
          setTimeout(function () {
            location.reload();
          }, 200);
        })
        .catch((error) => {
          this.alert(error.body.message, 'error');
        });

      this.blockScreen = false;
    },

    async checkSchedule() {
      this.requestDate();
      this.extensionAvailability();
    },
    requestDate() {
      this.checkoutDate = this.requestsInCheckout.end_date;
    },
    format(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatHour(hour) {
      return moment(hour).format('HH:mm');
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    info() {
      localStorage.setItem('showInfo', Boolean(true));
      console.log(localStorage.getItem('showInfo'));
      //this.Information.showInfo = localStorage.getItem("showInfo");
      this.$router.push('/user/informacao-reserva');
    },

    close() {
      this.showModalCreditCard = false;

      // Solicita pré-autorização de reservas
      this.VehicleRequestResource.requestPaymentAuthorization(
        localStorage.getItem('pickn_user')
      ).catch((e) => {
        this.alert('Erro ao buscar reservas.', 'error');
      });
    },

    mensagemAlerta(objeto) {
      this.alert(objeto.text, objeto.color);
    },

    async intersected() {
      this.getAllVehicleRequests();
    },

    async getConfigurations() {
      let configs = await this.configurationController.getAll();
      this.configurations = configs;
    },

    async checkCreditCard() {
      await this.userController.getUserData().then(async (res) => {
        await this.creditCardController.getByIdUser().then(
          (response) => {
            if (response.length >= 1) {
              this.cards = response;
              this.cardId = response[0].id;
              // Verifica se é um cliente de concessionária
            } else if (
              response.length == 0 &&
              res.client.type_client == 'concessionaria'
            ) {
              this.showModalCreditCard = true;
            }
          },
          (err) => {
            console.log(err);
            this.showModalCreditCard = true;
          }
        );
      });
    },

    totalValue(vr, km, lag) {
      vr = vr == null ? 0 : vr;
      km = km == null ? 0 : km;
      lag = lag == null ? 0 : lag;
      return parseFloat(vr) + parseFloat(km) + parseFloat(lag);
    },
    cancelledItem(items) {
      if (items.step.code == 'cancel' || items.step.code == 'auto-cancel')
        return false;
      return true;
    },

    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    changePage(change) {
      if (change == 'new') {
        this.showNewRequests = true;
        this.showOldRequests = false;
      } else {
        this.showNewRequests = false;
        this.showOldRequests = true;
      }
    },

    openDatails(vr) {
      this.changeDialog();
      this.vehicleRequestsDatail = vr;
    },

    changeDialog() {
      this.infoRequest = !this.infoRequest;
    },

    async getUser() {
      await this.userController
        .getUserData()
        .then((res) => {
          this.user = res.user;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    cleanVehicleRequests() {
      this.vehicleRequests = [];
      (this.vehicleRequestsNext = {
        page: 1,
        limit: 5,
      }),
        this.getAllVehicleRequests();
    },

    async getAllVehicleRequests() {
      if (this.vehicleRequestsNext) {
        await this.VehicleRequestResource.getVehicleRequestByUserId(
          this.vehicleRequestsNext.page,
          this.vehicleRequestsNext.limit
        )
          .then(async (res) => {
            if (res.next) {
              this.vehicleRequestsNext = res.next;
            } else {
              this.vehicleRequestsNext = null;
            }
            this.vehicleRequests = [
              ...this.vehicleRequests,
              ...res.vehicleRequests,
            ];

            console.log(this.vehicleRequests);
            await this.getRequestInCheckout();
            await this.getRequestInCheckIn();
          })
          .catch((e) => {
            this.alert('Erro ao buscar reservas.', 'error');
          });
      }
    },
    async openChat() {
      await this.userController.getUserData().then((res) => {
        zE('webWidget', 'identify', {
          name: res.user.name + '-' + res.client.name,
          email: res.user.email,
          organization: res.client.name,
          phone: res.user.phone,
        });
      });
      this.$zendesk.zE('webWidget', 'open');
    },

    async getRequestInCheckout() {
      this.requestsInCheckout = await this.vehicleRequests.find(
        (request) => request.step.code === 'check-out'
      );
    },

    async getRequestInCheckIn() {
      let requests = [];

      await this.vehicleRequests.map((request) => {
        if (request.step.code === 'check-in') {
          request.allowCheckIn = this.validateTimeCheckIn(request);

          requests.push(request);
        }
      });

      requests.sort((a, b) => {
        if (new Date(a.begin_date).getTime() < new Date(b.begin_date)) {
          return -1;
        }
        return 1;
      });

      this.requestsInCheckIn = requests;
    },

    validateTimeCheckIn(vehicleRequest) {
      let horaAtual = new Date().getTime();
      let horaCheckIn = moment(vehicleRequest.begin_date, 'YYYY-MM-DD HH:mm:ss')
        .toDate()
        .getTime();
      let diferenca = horaCheckIn - horaAtual;
      let timeMin = 60000 * Constants.CONFIG_VALUE_MINUTE_MIN_CHECKIN; //quantidade em minutos
      // let timeMax = -60000*Constants.CONFIG_VALUE_MINUTE_MAX_CHECKIN
      // if(diferenca<timeMin && diferenca>timeMax){
      return diferenca < timeMin ? true : false;
    },

    goToCheck(id) {
      this.$router.push({ path: `/user/reserva/${id}` });
    },

    async cancelVehicleRequest() {
      await this.VehicleRequestResource.cancelVehicleRequest(
        this.canlcelId,
        this.motiveCancel
      )
        .then((res) => {
          this.modalCancel = !this.modalCancel;
          this.motiveCancel = '';
          this.snackbarColor = 'success';
          this.snackbarText = 'Reserva cancelada com sucesso';
          this.snackbar = true;
          this.cleanVehicleRequests();
        })
        .catch((e) => {
          this.snackbarColor = 'error';
          this.snackbarText = 'Erro ao cancelar reserva';
          this.snackbar = true;
        });
    },

    openModal(id) {
      this.modalCancel = !this.modalCancel;
      this.canlcelId = id;
    },

    async checkTimeCancel(vehicleRequestId) {
      try {
        let vehicleRequest = await this.vehicleRequestController.getById(
          vehicleRequestId
        );
        if (vehicleRequest.client.type_client == 'usecarmais') {
          this.openModal(vehicleRequestId);
          return;
        }
        let date = new Date();
        let reservationBeginDate = new Date(vehicleRequest.begin_date);
        let minutesBeforeCancelation = this.configurations
          .limit_minutes_before_cancelation.value;
        minutesBeforeCancelation = Number.parseInt(
          minutesBeforeCancelation ? minutesBeforeCancelation : 15
        );

        let limitDate = new Date(
          reservationBeginDate.setMinutes(
            reservationBeginDate.getMinutes() - minutesBeforeCancelation
          )
        );

        let onOk = async () => {
          await this.openModal(vehicleRequestId);
        };
        let onCancel = () => {
          return;
        };

        if (date > limitDate) {
          this.$awn.confirm(
            `Essa reserva possui prazo de cancelamento posterior ao permitido e terá
             seu valor integral cobrado. Deseja continuar?`,
            onOk,
            oncancel
          );
        } else {
          this.openModal(vehicleRequestId);
        }
      } catch (error) {
        this.$awn.alert(error);
      }
    },

    async openDoors(vehicle_id) {
      await this.vehicleController
        .changeStatusForce(vehicle_id, 'unlock')
        .then((res) => {
          this.responseDoors.mensagem = 'Comando enviado!';
          this.responseDoors.ok = true;
        })
        .catch((e) => {
          this.responseDoors.mensagem = 'Falha o enviar comando';
          this.responseDoors.ok = false;
        });
    },
    allowedStep: (m) => m % 10 === 0,
  },
};
</script>

<style scoped>
.container {
  position: relative;
  height: 100vh;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.changePage {
  position: fixed;
  top: 48px;
  z-index: 1;
}

.sizeTop {
  height: 48px;
}

.bottom {
  margin-bottom: 60px;
}

.exit {
  position: fixed;
  right: 0;
  top: 0px;
}

.colorSelected {
  color: var(--secondary-color);
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.btnColor {
  background-color: var(--primary-color) !important;
}

.btnInfo {
  background-color: white;
}

.float {
  position: absolute;
  color: var(--secondary-color);
  top: 0;
  right: 0;
}

.icon-size {
  font-size: 60px;
}

.icon-info {
  color: var(--secondary-color);
}

.btnGroup {
  margin: 5px;
  color: var(--secondary-color);
  font-weight: 700;
}
/* .newRequest {
  margin-top: 96px;
  margin-bottom: 56px;
}

.oldRequest {
  margin-top: 96px;
  margin-bottom: 56px;
} */

.moment {
  margin-bottom: 20px;
}

.vehicle {
  display: flex;
}

.modelo {
  font-size: 16px;
  color: #181f4d;
}

.caption {
  color: #181f4d;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.cardContent > hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.vehicleImg {
  margin-left: -10px;
}

.cardRadius {
  border-radius: 4px;
}

.border {
  border: 2px solid grey;
}

.borderBottomIn {
  border-bottom: 1px solid var(--secondary-color);
}

.borderBottomOut {
  border-bottom: 1px solid var(--orange-color);
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.checkin {
  background-color: var(--secondary-color) !important;
}

.checkin-text {
  color: var(--secondary-color);
}

.checkout {
  background-color: var(--orange-color) !important;
}

.checkout-text {
  color: var(--orange-color);
}

.total {
  color: #993399;
}

.carImage {
  border-radius: 6px;
}

.floatBtn {
  position: fixed;
  bottom: 100px;
  right: 4px;
  outline: none;
}

.colorBtn {
  background-color: var(--green-color) !important;
  color: white;
  text-decoration: none;
  text-transform: none;
}
.newConteiner {
  padding-left: 40px;
  padding-right: 50px;
  padding-bottom: 10px;
  align-items: center;
}
.float {
  position: absolute;
  top: 8px;
  right: 8px;
}
.primary {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.newCheckContainer {
  font-size: 25px;
  line-height: 50px;
}
.card-padding {
  padding-left: 16px;
  padding-right: 16px;
}
.backgroundPrimary {
  background-color: var(--primary-color) !important;
}
.fontPrimary {
  color: var(--primary-color) !important;
}
.rightButtons {
  position: absolute;
  padding-top: 10px;
  right: 0px;
  bottom: 5px;
}
.defaultPadding {
  padding-right: 32px;
  padding-left: 32px;
}
.y-spacing {
  padding-top: 17%;
  padding-bottom: 15%;
}
</style>
